var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1379.01 618.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M762.61,618.88c-18.08,0-36.36-2.85-54.16-8.52-63.8-20.33-103.5-69.71-106.21-132.11-4.17-96.22,65.36-173.98,95.45-202.95,9.92-9.55,20.61-18.37,32.07-26.47-11.2-9.79-21.41-18.05-29.48-24.59C494.99,58.18,147.92,73.83,8.22,88.27L0,8.69C149.57-6.77,522.13-22.77,750.59,162.04c13.24,10.71,33.32,26.95,54.88,47.76,24.9-9.05,51.99-15.88,81.19-20.44,61.29-9.57,132.47-9.25,211.57.95,131.17,16.92,248.07,56.5,280.77,68.22l-27,75.3c-36.36-13.04-305.33-105.5-489.2-58.38,36.12,50.74,54.67,102.81,55.21,155.07.64,61.54-14.2,109.4-44.1,142.27-18.77,20.63-44.37,35.12-74.04,41.91-12.16,2.79-24.67,4.17-37.27,4.17ZM786.56,307.03c-12.02,7.5-23.21,16.1-33.38,25.9-17.38,16.73-73.85,76.4-71.01,141.86,1.65,38.15,32.39,53.56,50.57,59.35,36.33,11.57,67.98.25,82.01-15.18,10.91-11.99,23.8-36.92,23.28-87.6-.48-46.9-23.37-89.31-51.46-124.32Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine1);
export default __webpack_public_path__ + "static/media/line_1.a001ea779d0866d14881b237e8446eff.svg";
export { ForwardRef as ReactComponent };